window.$ = window.jQuery = require('jquery')

require('bootstrap')
window.AOS = require('aos');
require('./pageTransition.js')
// window.SmoothScroll = require('smooth-scroll');
window.Rellax = require('rellax');
window.Vue = require('vue');


/*
 * Script.js
 */
// $(window).on('load',function(){
//   var scroll = new SmoothScroll('a[href*="#"]', {
//     speed: 2500,
//     easing: 'easeInOutCubic',
//   speedAsDuration: true
//   });
//   console.log('ok');
// })

$(function () {
  // const scroll = new LocomotiveScroll({
  //   el: document.querySelector('main'),
  //   smooth: true,
  //   lerp: 0.1
  // });
  smoothScroll();
  slideMenu();
  // spMenuShow();
  setColorSVG();

  $(window).on('resize', function () {
    var timerId;
    slideMenu();
    smoothScroll();
    $('.main-menu > li > a').removeClass('sp-menu-open');
    $('.sub-menu').removeAttr('style');
  });


});

/*
    スムーススクロール
====================================*/
function smoothScroll() {
  // $('a[href^="#"]').off('click.smoothScroll');
  $('a[href^="#"]').on('click.smoothScroll', function(e) {
    // e.preventDefault();
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);

    if (href != '#none') {
      var position = target.offset().top - $('header').outerHeight(true);
      // console.log(href);
      if(href == '#wallpaper'){
        position = position - 1170;
      }
      // $('body').scrollTop(position);
      // window.scrollTo({
      //   top: position,
      //   behavior: "smooth"
      // });
    }

    if ($('.main-menu').css('display') === 'flex') {
      // PCの場合
      $('header').removeClass('is-open');
      $('.main-menu').removeClass('is-open');
      $('.sub-menu').removeClass('active').removeAttr('style');

      var timerId;
      timerId = setTimeout(function() {
        $('header').removeClass('is-open');
        $('.main-menu').removeClass('is-open');
        $('.sub-menu').removeClass('active').removeAttr('style');
      }, 300);
    } else {
      // SPの場合
      // サブメニューの場合
      var logo_link = $(this).parent('div').attr('id');
      if ($(this).find('img').length !== 0 && logo_link === undefined) {
        $('header.navbar nav').removeClass('active');
        $('.btn-trigger2').removeClass('active');
      }
    }

    // return false;
  });


  var hashString = location.hash.substr(1);
  if (hashString !== "" && $('#'+hashString).length) {
    var position = $(location.hash).offset().top;
    $('html, body').animate({ scrollTop: position }, 1);

    history.replaceState('', document.title, window.location.pathname);

    return false;
  }
}

/*
    サブメニューのアコーディオン表示
====================================*/
function slideMenu() {
  // タイマー初期化
  var timerId;
  // hover処理初期化
  $('.main-menu > li').off();
  // メニューをhoverしたら
  $('.main-menu > li').on({
    'mouseenter': function() {
      // PCの場合（display: flex）
      if ($('.main-menu').css('display') === 'flex') {
        if ($('.main-menu').hasClass('is-open')) { // すでにメニューが開いており、別のメニューを選択した場合
          // サブメニューが存在しないメニューの場合
          if ($(this).children('a').next('div').length == 0) {
            // スライドでメニューを閉じる
            $('header').removeClass('is-open');
            $('.main-menu').removeClass('is-open');
            $('.sub-menu').removeClass('active').removeAttr('style');
          } else {
            // thisの値をthatに代入
            var that = this;
            // タイマーが起動する前の処理はしない
            if (timerId > 0) {
              clearTimeout(timerId);
            }
            // 0.3秒後に発火
            timerId = setTimeout(function() {
              // hoverしたメニューを表示し、他を非表示にする
              $('.sub-menu').removeClass('active').stop().fadeOut();
              $(that).find('.sub-menu').addClass('active').stop().fadeIn();
            }, 300);
          }
        } else { // メニューが閉じている場合
          if ($(this).children('a').next('div').length != 0) {
            // thisの値をthatに代入
            var that = this;
            // タイマーが起動する前の処理はしない
            if (timerId > 0) {
              clearTimeout(timerId);
            }
            // 0.3秒後に発火
            timerId = setTimeout(function() {
              // activeクラスを追加してメニューをスライドで表示させる
              var header_height = getHeightHeaderMenu();
              $('header').addClass('is-open');
              $('.main-menu').addClass('is-open');
              $(that).find('.sub-menu').addClass('active')
              $('.sub-menu').css('height', header_height);
              $('.sub-menu:not(".active")').css('display', 'none');
            }, 300);
          }
        }
      }
    }
  });

  // メニューからhoverが外れたら
  $('.main-menu').on({
    'mouseleave': function() {
      // PCの場合（display: flex）
      if ($('.main-menu').css('display') === 'flex') {
        // タイマーが起動する前の処理はしない
        if (timerId > 0) {
          clearTimeout(timerId);
        }
        // 0.3秒後に発火
        timerId = setTimeout(function() {
          // スライドでメニューを閉じる
          $('header').removeClass('is-open');
          $('.main-menu').removeClass('is-open');
          $('.sub-menu').removeClass('active').removeAttr('style');
        }, 300);
      }
    }
  });

  // SPの場合
  if ($('.main-menu').css('display') !== 'flex') {
    $('.main-menu > li > a').on('click',function(){
      $('nav,.btn-trigger2').removeClass('active');
    })
    // $('.main-menu > li > a').off('click.spSubMenuShow');
    // $('.main-menu > li > a').on('click.spSubMenuShow', function() {
    //   if ($('.main-menu').css('display') !== 'flex') {
    //     if ($(this).hasClass('sp-menu-open')) { // sp-menu-openクラスがあればアコーディオンを閉じる
    //       $(this).removeClass('sp-menu-open').next('div').slideUp();
    //     }
    //     else { // sp-menu-openクラスがなければアコーディオンを開く
    //       $(this).addClass('sp-menu-open').next('div').slideDown();
    //     }
    //     return false;
    //   }
    // });
  }
}

/*
    グロナビの高さを揃える
====================================*/
function getHeightHeaderMenu() {
  if ($('.main-menu').css('display') === 'flex') {
    // style属性を削除
    $('.sub-menu').removeAttr('style');
    var maxHeight = 0;
    // もしdivがmaxHeightの値より大きい場合はdivの高さを全部合わせる
    $('.sub-menu > .container').each(function() {
      if ($(this).height() > maxHeight) { maxHeight = $(this).outerHeight(); }
    });
    return maxHeight;
  } else {
    $('.sub-menu').removeAttr('style');
  }
}

/*
    モバイル時のメニュー表示・非表示
====================================*/
function spMenuShow() {
  $('.btn-trigger2').off('click.spMenuShow');
  $('.btn-trigger2').on('click.spMenuShow', function() {
    // console.log('ok2');
    $('header.navbar nav').toggleClass('active');
    $(this).toggleClass('active');
    return false;
  });
}

/*
    SVGの背景色をCSSで変更できるようにする
    参考：https://bre.is/gtNkMxEM
====================================*/
function setColorSVG() {
  $('img.svg').each(function(){
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(imgURL, function(data) {
      // Get the SVG tag, ignore the rest
      var $svg = $(data).find('svg');

      // Add replaced image's ID to the new SVG
      if(typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if(typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass+' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
      if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
      }

      // Replace image with new SVG
      $img.replaceWith($svg);

    }, 'xml');

  });
}
